module.exports = __webpack_public_path__ + "img/54.fe913033.jpg";